import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom'; 
import SearchInput from "../../components/SearchInput"; 
import Loader from "../../components/Loader"; 
import { authFetch } from "../../utils/api";
import "../../styles/admin/aseguradoras.css"; 

export default function Transportistas() {
  const [q, setQ] = useState("");
  const [transportistas, setTransportistas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate(); 

  useEffect(() => {
    setLoading(true);
    setError(null);

    authFetch('/api/Transportistas') 
      .then(res => {
        if (!res.ok) {
          throw new Error('No se pudieron cargar los transportistas.');
        }
        return res.json();
      })
      .then(data => {
        setTransportistas(data);
      })
      .catch(err => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []); 

  const rows = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return transportistas; 
    return transportistas.filter(r =>
      [r.nombre, r.telefono, r.correoElectronico].some(v => String(v).toLowerCase().includes(t))
    );
  }, [q, transportistas]); 

  const handleAgregar = () => {
    navigate('/admin/transportistas/agregar');
  };

  const handleEditar = (transportista) => {
    navigate(`/admin/transportistas/editar/${transportista.id}`);
  };

  const handleDelete = async (transportista) => {
    if (!window.confirm(`¿Estás seguro de que deseas eliminar a ${transportista.nombre}?`)) {
      return;
    }

    try {
      const response = await authFetch(`/api/Transportistas/${transportista.id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Error al eliminar el transportista.');
      }

      setTransportistas(prevTransportistas => 
        prevTransportistas.filter(t => t.id !== transportista.id)
      );

    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <main className="aseg-main">
      <header className="aseg-header">
        <h1 className="aseg-title">Transportistas</h1>
        <button 
          type="button" 
          className="aseg-btn" 
          onClick={handleAgregar}
        >
          Agregar Transportista
        </button>
      </header>

      <SearchInput
        placeholder="Buscar transportistas"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />

      <section className="aseg-card">
        {loading && <Loader message="Cargando transportistas..." />}

        {error && (
          <div className="aseg-error">
            Error: {error}
          </div>
        )}

        {!loading && !error && (
          <div className="aseg-table-wrapper">
            <table className="aseg-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Correo electrónico</th>
                  <th className="col-acciones">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map(r => (
                    <tr key={r.id}>
                      <td>{r.nombre}</td>
                      <td>{r.telefono}</td>
                      <td className="td-email">{r.correoElectronico}</td>
                      <td className="td-acciones">
                        <button 
                          type="button" 
                          className="aseg-link" 
                          onClick={() => handleEditar(r)}
                        >
                          Editar
                        </button>
                        <button 
                          type="button" 
                          className="aseg-link aseg-link-danger" 
                          onClick={() => handleDelete(r)}
                        >
                          Borrar
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="aseg-empty">
                      No se encontraron transportistas{q ? ' que coincidan con la búsqueda' : ''}.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </main>
  );
}